import { CIcon } from '~/icons/types'

export const ciSpeedboat: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.671 10.82a.5.5 0 0 0-.428-.242h-3.8L16.331 6.21a.5.5 0 0 0-.539-.193L8.417 8.026a.5.5 0 0 0-.3.236l-1.313 2.313H.501a.5.5 0 0 0-.5.5v3.227a.5.5 0 0 0 .5.5h.653l.847 2.6a.5.5 0 0 0 .476.345h13.705a7.153 7.153 0 0 0 6.2-3.99l1.3-2.448a.5.5 0 0 0-.011-.49Zm-5.46-.242h-2.353l-2.114-2.966 1.969-.537 2.498 3.503Zm-9.328-1.64 3.835-1.046 1.915 2.686H7.951l.932-1.64Zm-7.88 2.64h13.05a75.92 75.92 0 0 0-.632.236c-2.352.886-5.281 1.99-11.9 1.99h-.52l.002-2.226Zm20.5 1.713a6.158 6.158 0 0 1-5.317 3.459H2.84l-.636-1.954c3.955.101 7.89-.594 11.57-2.046a13.549 13.549 0 0 1 5.4-1.172h3.229l-.9 1.713Z',
      fill: 'currentColor'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'speedboat',
  type: 'thin'
}
